import { useCoreInput } from "@Shared/@Composables/inputs/useCoreInput";
import { useInputMask } from "@Shared/@Composables/inputs/useInputMaks";
import { computed, defineComponent, ref, toRefs, watch, nextTick } from "@vue/composition-api";
import { uniqueId } from "lodash";
import BaseInput from "../base/base-input.vue";
import BaseLabel from "../base/base-label.vue";
import BaseFieldLayout from "../base/base-field-layout.vue";
export default defineComponent({
  name: "TextField",
  components: {
    BaseLabel,
    BaseFieldLayout,
    BaseInput
  },
  props: {
    value: {
      type: null,
      default: ""
    },
    id: {
      type: String,
      default: () => uniqueId()
    },
    name: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    validator: {
      type: Object,
      default: null
    },
    inputType: {
      type: String,
      default: "text"
    },
    sideGrid: {
      type: Boolean,
      default: false
    },
    inputMask: {
      type: Object,
      default: null
    },
    maskType: {
      type: String,
      default: ""
    },
    onType: {
      type: Boolean,
      default: false
    },
    showRequiredIndicator: {
      type: Boolean,
      default: false
    },
    showMaxLengthLabel: {
      type: Boolean,
      default: true
    },
    maxLength: {
      type: Number,
      default: null
    },
    clientLogin: {
      type: Boolean,
      default: false
    },
    hiddenLabel: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    var _valueModel$value;
    const {
      value,
      inputMask,
      maskType,
      onType,
      showMaxLengthLabel,
      maxLength
    } = toRefs(props);
    const {
      hasFocus,
      handleBaseFocus,
      handleBaseBlur,
      handleBaseChange,
      handleBaseInput,
      handleKeypressEnter,
      valueModel
    } = useCoreInput({
      value,
      onType: onType.value
    });
    const localValue = ref((_valueModel$value = valueModel == null ? void 0 : valueModel.value) != null ? _valueModel$value : "");
    let inputMaskToUse = inputMask.value;
    if (maskType.value) {
      const {
        buildMaskFromStringType
      } = useInputMask();
      const {
        inputMask: mask
      } = buildMaskFromStringType({
        type: maskType.value,
        options: inputMask.value
      });
      inputMaskToUse = mask;
    }
    watch(valueModel, newVal => {
      if (maxLength.value && showMaxLengthLabel.value && newVal.toString().length > maxLength.value) {
        nextTick(() => {
          valueModel.value = newVal.toString().substring(0, maxLength.value);
        });
      }
      localValue.value = valueModel.value.toString();
    });
    const localValueLength = computed(() => {
      var _localValue$value$toS, _localValue$value;
      return (_localValue$value$toS = (_localValue$value = localValue.value) == null ? void 0 : _localValue$value.toString().length) != null ? _localValue$value$toS : 0;
    });
    const handleInput = event => {
      if (showMaxLengthLabel.value && maxLength.value) localValue.value = (event == null ? void 0 : event.target).value;
      handleBaseInput(event);
    };
    return {
      valueModel,
      hasFocus,
      handleBaseFocus,
      handleBaseBlur,
      handleBaseChange,
      handleBaseInput,
      handleKeypressEnter,
      inputMaskToUse,
      localValue,
      localValueLength,
      handleInput
    };
  }
});